module.exports = __webpack_public_path__ + "static/hillary-clinton-c54bb6fd8a8655e1d76ea7606f883838.jpg";